<template>
    <div class="container"
    @wheel="roll_away">
        <div class="main-box">
            <div class="lucida-icon">
                <img src="../../assets/image/index_v2/Group.svg" alt="">
            </div>
            <div class="title">
                <div><span class="emphasize">Lucida is a</span></div>
                <div>multi-strategy</div>
                <div>hedge fund built</div>
                <div>for&nbsp;<span class="emphasize">Bitcoin trading</span></div>
            </div>
            <div class="user-info">
                <div class="info-item">
                    It has leading performance in arbitrage,<br />
                    market-making, and directional strategies.
                </div>
                <div class="info-item">
                    Its team consists of over 20 experienced<br />
                    researchers and asset managers based in<br />
                    Hong Kong, London and New York.
                </div>
                <div class="info-item">
                    Lucida was founded in 2018<br />
                    by Naiqian Zheng
                </div>
                <div class="info-item">
                    and its co-managing partners are<br />
                    Fabian Bjorklund and Hao Guang
                </div>
            </div>
        </div>
        <div @click="page_turning()" class="down-svg">
            <img src="../../assets/image/index_v2/down.svg" alt="">
        </div>
        <div class="contact-info">
            <div class="y-line"></div>
            <div class="contact-item">
                <span>For inquiries please contact info</span>&nbsp;<span class="contact-item-w">contact@lucida.fund</span>
            </div>
            <div class="contact-item">
                <span>Exceptional people should contact</span>&nbsp;<span class="contact-item-w">work@lucida.fund</span>
            </div>
        </div>
        <div class="line"></div>
        <div class="bottom-info">
            <div class="bottom-info-left">
                <span>Copyright 2025</span>
                <img class="jump-to" @click="goto_url('https://x.com/lucidafund')" src="../../assets/image/index_v2/Group 27153.svg" alt="">
                <img class="jump-to" @click="goto_url('https://mirror.xyz/lucidafund.eth')" src="../../assets/image/index_v2/Group 27154.svg" alt="">
                <img class="jump-to" @click="goto_url('https://www.linkedin.com/company/81970900')" src="../../assets/image/index_v2/Group 27157.svg" alt="">
                <img class="jump-to" @click="goto_url('https://medium.com/@Lucida_and_Falcon')" src="../../assets/image/index_v2/Group 27156.svg" alt="">
                <img class="jump-to" @click="goto_url('https://github.com/lucidagithub')" src="../../assets/image/index_v2/Group 27158.svg" alt="">
            </div>
            <div class="bottom-info-right">
                Lucida's funds are registered in the Cayman Islands.<br />
                Lucida does not solicit or accept retail investment.<br />
                <hr>
            </div>
        </div>
    </div>
</template>

<style scoped>
    @font-face {
        font-family: "PalanquinDark-Bold";
        src: url("../../assets/fonts/index_v2/PalanquinDark-Bold.ttf");
    }
    @font-face {
        font-family: "PalanquinDark-Medium";
        src: url("../../assets/fonts/index_v2/PalanquinDark-Medium.ttf");
    }
    @font-face {
        font-family: "PalanquinDark-Regular";
        src: url("../../assets/fonts/index_v2/PalanquinDark-Regular.ttf");
    }
    @font-face {
        font-family: "PalanquinDark-SemiBold";
        src: url("../../assets/fonts/index_v2/PalanquinDark-SemiBold.ttf");
    }
    .container {
        width: 92%;
        height: 100%;
        margin-left: 4%;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .main-box {
        position: relative;
        margin-top: 8%;
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .lucida-icon{
        transition: transform 0.6s ease;
    }
    .title {
        font-family: PalanquinDark-Medium;
        font-size: 92px;
        transition: transform 0.6s ease, opacity 0.6s ease;
    }
    .title>div{
        display: flex;
        align-items: center;
        height: 124px;
        overflow: hidden;
    }
    .down-svg{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px 0;
        width: 30px;
        height: 30px;
        overflow: hidden;
        cursor: pointer;
        user-select: none;
        transition: transform 0.6s ease;
        transform-origin: center;
    }
    .down-svg img{
        filter: drop-shadow(#fff 200px 0);
        transform: translateX(-200px);
    }
    .line{
        width: 100%;
        height: 1px;
        background-color: #fffa;
    }
    hr {
        background-color: #fffa;
        height: 1px;
        border: none;
    }
    .emphasize {
        background-color: #0045FF;
    }
    .bottom-info {
        font-family: PalanquinDark-Regular;
        font-size: 16px;
        margin: 10px 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .bottom-info-left {
        display: flex;
        align-items: center;
    }
    .bottom-info-left>span{
        margin-right: 16px;
        opacity: .6;
    }
    .bottom-info-left>img{
        width: 28px;
        cursor: pointer;
        user-select: none;
        margin-right: 12px;
    }
    .bottom-info-right {
        text-align: right;
        line-height: 20px;
    }
    .contact-info {
        position: relative;
        margin-bottom: 50px;
        width: 100%;
        font-size: 18px;
        opacity: 0;
        transition: opacity 0.6s ease;
    }
    .contact-item{
        font-family: PalanquinDark-Regular;
        display: inline-block;
        margin-right: 8%;
    }
    .contact-item>span:nth-child(1){
        margin-left: 14px;
    }
    .contact-item-w{
        font-family: PalanquinDark-Bold;
        cursor: pointer;
        color: #0045FF;
    }
    .y-line {
        position: absolute;
        width: 1px;
        height: 140px;
        background-color: #fffa;
        bottom: 6px;
    }
    .user-info{
        font-family: PalanquinDark-Regular;
        position: absolute;
        text-align: right;
        right: 0;
        opacity: 0;
        transition: opacity 0.6s ease;
        font-size: 28px;
        line-height: 32px;
        overflow: hidden;
    }
    .info-item{
        margin-top: 24px;
    }
    @media screen and (min-width:1024px) and (max-width:1440px){
        .main-box {
            margin-top: 12%;
        }
        .title {
            font-size: 70px;
        }
        .title>div{
            height: 100px;
        }
        .user-info{
            font-size: 20px;
            line-height: 26px;
        }
        .contact-info {
            margin-bottom: 20px;
        }
        .y-line {
            height: 100px;
        }
        .contact-item {
            margin-right: 4%;
        }
    }
    @media screen and (max-width:1024px){
        .main-box {
            margin-top: 12%;
        }
        .title {
            font-size: 50px;
        }
        .title>div{
            height: 80px;
        }
        .user-info{
            font-size: 18px;
            line-height: 20px;
        }
        .info-item{
            margin-top: 16px;
        }
        .contact-info {
            margin-bottom: 20px;
        }
        .y-line {
            height: 100px;
        }
        .contact-item {
            margin-right: 4%;
        }
    }
</style>

<script>
export default {
  data() {
    return {
        pageCount: 0,
        pageTotal: 2,
        timerId: null,
    };
  },
  watch: {
    pageCount(newValue, oldValue){
        if(newValue === oldValue) return;
        let down = document.querySelector('.down-svg');
        let lucidaIcon = document.querySelector(".lucida-icon");
        let title = document.querySelector(".title");
        let userInfo = document.querySelector(".user-info");
        let contactInfo = document.querySelector(".contact-info");
        if (newValue == 1) {
            down.style.transform = `rotate(180deg)`;
            let rect = lucidaIcon.getBoundingClientRect(); // 计算偏移量
            let h = document.body.clientHeight * 0.07;
            lucidaIcon.style.transform = `translateY(-${rect.top-h}px)`;
            rect = title.getBoundingClientRect(); // 计算偏移量
            let w = document.body.clientWidth * 0.04;
            title.style.transform = `translateX(-${rect.left-w}px)`;
            title.style.opacity = '0.5';
            userInfo.style.opacity = '1';
            contactInfo.style.opacity = '1';
        } else {
            down.style.transform = `rotate(0deg)`;
            lucidaIcon.style.transform = 'translateY(0)';
            title.style.transform = 'translateX(0)';
            title.style.opacity = '1';
            userInfo.style.opacity = '0';
            contactInfo.style.opacity = '0';
        }
    }
  },
  methods: {
    // touchStartHandler(e) {
    //     if(e.target.className !== 'jump-to' && e.target.className !== 'down-svg'){
    //         e.preventDefault();
    //     }
    // },
    // touchEndHandler(e) {
    //     if(e.target.className !== 'jump-to' && e.target.className !== 'down-svg'){
    //         e.preventDefault();
    //     }
    // },
    roll_away(e) {
        if(e.deltaY > 0 && this.pageCount < (this.pageTotal - 1)) {
            if(this.timerId === null) {
                this.pageCount++;
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
            }
        }
        else if(e.deltaY < 0 && this.pageCount > 0) {
            if(this.timerId === null) {
                this.pageCount--;
                this.timerId = setTimeout(() => {
                    this.timerId = null;
                }, 600);
            }
        }
    },
    page_turning() {
        if(this.timerId === null) {
            this.pageCount = (this.pageCount + 1) % this.pageTotal;
            this.timerId = setTimeout(() => {
                this.timerId = null;
            }, 600);
        }
    },
    goto_url(url) {
        if(url) window.open(url);
    },
  }
};
</script>